import { render, staticRenderFns } from "./AboutMission.vue?vue&type=template&id=44359642&"
import script from "./AboutMission.vue?vue&type=script&lang=js&"
export * from "./AboutMission.vue?vue&type=script&lang=js&"
import style0 from "./AboutMission.vue?vue&type=style&index=0&id=44359642&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports